<script setup lang="ts">
const props = defineProps<{
  list: {
    title: string;
    subtitle: string;
    '1': {
      title: string;
      list: Record<string, string>;
    };
    '2': {
      title: string;
      list: Record<string, string>;
    };
    '3': {
      title: string;
      list: Record<string, string>;
    };
  };
  themeKeys: {
    bg: string;
    title: string;
    features: string;
  };
}>();
</script>

<template>
  <div
    class="outer-p-container transition duration-500"
    :style="{
      backgroundColor: props.themeKeys.bg,
    }"
  >
    <div class="inner-container">
      <h3
        :style="{
          color: props.themeKeys.title,
        }"
        class="text-center font-semibold text-4xl mb-2 lg:mb-4"
      >
        {{ props.list.title }}
      </h3>
      <h4
        :style="{
          color: props.themeKeys.title,
        }"
        class="text-center mb-8 lg:mb-12 w-2/3 mx-auto"
      >
        {{ props.list.subtitle }}
      </h4>
      <div
        class="flex flex-row flex-wrap items-start justify-center gap-12 p-6"
      >
        <div
          v-for="category in ['1', '2', '3']"
          class="w-xs text-center"
        >
          <h2
            class="text-xl lg:text-2xl font-semibold mb-4 text-center"
            :style="{
              color: props.themeKeys.title,
            }"
          >
            {{ props.list[category].title }}
          </h2>
          <ul :style="{ color: props.themeKeys.features }">
            <li
              v-for="item in Object.values(props.list[category].list)"
              class="pb-2"
            >
              <Icon
                name="i-lucide-check"
                class="align-middle"
              />
              {{ item }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
